// To generate a new file similar to this one, run `pay js:run gql-v1 --type=lazy-query --name=<name> --dir=path/to/dir`.
// You can freely edit this file. To update the generated types, run `eslint` in `--fix` mode.
// Do not delete this comment. https://go/gql-operation-definition

/* eslint-disable @stripe-internal/data-v1/camel-case-alias */

import type {
  V1LazyQueryOptions,
  V1LazyQueryOptionsWithoutVariables,
  V1LazyQueryReturn,
  AccountToken,
} from '@stripe-internal/data-v1/types';
import {gql} from '@sail/data';
import {useV1LazyQuery} from '@stripe-internal/data-v1';

import type {
  GraphQlDocument,
  GraphQlFragmentUnion,
  HookVariables,
} from '@sail/data';

import type {
  Exact,
  InputMaybe,
  OpenapiGetV1CryptoInternalSetupSessionInput,
  V1ContextInput,
} from '@stripe-internal/data-v1/schema/types';
import {setupSessionFragment} from 'src/api/graphql/setupSessionFragment';

import type {
  SetupSessionFragmentData,
  SetupSessionFragmentToken,
} from 'src/api/graphql/setupSessionFragment';

const doc = gql`
  query SetupSessionLazyQuery(
    $input: OpenapiGetV1CryptoInternalSetupSessionInput
    $v1Context: V1ContextInput!
  ) {
    v1CryptoInternalSetupSession(input: $input, v1Context: $v1Context) {
      id
      ...SetupSessionFragment
    }
  }
  ${setupSessionFragment}
`;

export const setupSessionLazyQuery: SetupSessionLazyQueryDocument = doc;

// Fill these options as needed. Options are documented at
// http://go/sail/apis/data/graphql-usage/the-basics-runtime#operation-options
const setupSessionLazyQueryOptions: V1LazyQueryOptionsWithoutVariables<SetupSessionLazyQueryDocument> =
  {
    fetchPolicy: 'no-cache',
  };

export default function useSetupSessionLazyQuery<
  THookVariables extends HookVariables<SetupSessionLazyQueryVariables> = {},
>(
  options: V1LazyQueryOptions<SetupSessionLazyQueryDocument, THookVariables>,
): V1LazyQueryReturn<SetupSessionLazyQueryDocument, THookVariables> {
  return useV1LazyQuery(setupSessionLazyQuery, {
    ...setupSessionLazyQueryOptions,
    ...options,
  });
}

// THIS IS AUTOGENERATED CODE, DO NOT EDIT AS YOUR CHANGES WILL BE BLOWN AWAY
// Regenerate it using eslint in fix mode.

export type SetupSessionLazyQueryVariables = Exact<{
  input?: InputMaybe<OpenapiGetV1CryptoInternalSetupSessionInput>;
  v1Context: V1ContextInput;
}>;

export type SetupSessionLazyQueryData = {
  readonly __typename: 'Query';
  readonly v1CryptoInternalSetupSession: GraphQlFragmentUnion<
    {
      readonly __typename: 'OpenapiCryptocurrencyPayinsResourceCryptoSetupSession';
      readonly id: string;
    },
    [SetupSessionFragmentData]
  > | null;
};

export type SetupSessionLazyQueryToken = SetupSessionFragmentToken &
  AccountToken<{Query_v1CryptoInternalSetupSession: true}>;

export type SetupSessionLazyQueryDocument = GraphQlDocument<
  SetupSessionLazyQueryData,
  SetupSessionLazyQueryVariables,
  SetupSessionLazyQueryToken
>;
